<kiwi-decision-header
    [title]="titleLabelKey | translate"
    [decisionIsInvalid]="currentComponent != null && currentComponent.isFormInvalid()"
    (saved)="onSave()">
</kiwi-decision-header>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-y tabsDecisionContainer">
    <kiwi-tabs class="cell shrink tabsDecision" *ngIf="tabs" [tabs]="tabs | async"></kiwi-tabs>
    <router-outlet (activate)="onRouterActivate($event)"></router-outlet>
</div>
